(function () {
  class GigaBloxIntroAnim extends PIXI.Container {
    constructor() {
      super();

      this.visible = false;
      gameData.gigaBloxIntroAnim = this;
    }

    initialise() {
      messageBus.subscribe('spinner:GameConfigEvent', (event) => {
        this.onLayoutComplete();
      });
      messageBus.subscribe('game:blockDistribution', (event) => {
        this.onBlockDistribution(event);
      });
    }

    onLayoutComplete() {
      this.baseName = this.name + ':';
      this.grabReferences();
      this.setupSpineAnims();
      this.setupParticles();
    }

    grabReferences() {
      this.gigabloxFactory = resourceManager.get('slotContainer:GigabloxFactory');
    }

    setupSpineAnims() {}

    setupParticles() {
      // we need 6 emitters
      const coords = [
        { x: 0, y: 0 },
        { x: 126, y: 0 },
        { x: 252, y: 0 },
        { x: 378, y: 0 },
        { x: 504, y: 0 },
        { x: 630, y: 0 },
      ];
      for (let i = 0; i < coords.length; i++) {
        const emitter = particleManager.createEmitter(
          'reel_sparks_emitter',
          this.baseName + 'particleContainer',
          coords[i].x,
          coords[i].y,
          false
        );
        emitter.particleEmitter.emit = false;
        this[`particleEffect${i}`] = emitter;
      }

      this.particlesPerPattern = {
        '1-1-1-2': [this.particleEffect3, this.particleEffect5],
        '1-1-2-1': [this.particleEffect2, this.particleEffect4],
        '1-2-1-1': [this.particleEffect1, this.particleEffect3],
        '2-1-1-1': [this.particleEffect0, this.particleEffect2],
        '1-2-2': [this.particleEffect1, this.particleEffect3, this.particleEffect5],
        '2-1-2': [this.particleEffect0, this.particleEffect2, this.particleEffect3, this.particleEffect5],
        '2-2-1': [this.particleEffect0, this.particleEffect2, this.particleEffect4],
        '1-1-3': [this.particleEffect2, this.particleEffect5],
        '1-3-1': [this.particleEffect1, this.particleEffect4],
        '3-1-1': [this.particleEffect0, this.particleEffect3],
        '2-3': [this.particleEffect0, this.particleEffect2, this.particleEffect5],
        '3-2': [this.particleEffect0, this.particleEffect3, this.particleEffect5],
      };
    }

    async onBlockDistribution(event) {
      // should we only join if the block distribution changes?
      if (this.gigabloxFactory.doesActiveLayoutMatchThisLayout(event.data.gigabloxLayout) === false) {
        event.join();

        let transitionResolver = null;
        const transitionPromise = new Promise((resolve) => {
          transitionResolver = resolve;
        });

        let modifierResolver = null;
        const modifierPromise = new Promise((resolve) => {
          modifierResolver = resolve;
        });

        if (event.data.blockDistribution !== '1-1-1-1-1') {
          // we are changing and its not a boring layout
          await timerManager.delayAsync(500);
        } else {
          // just give a bit of time for the symbols above to fall through
          await timerManager.delayAsync(250);
        }

        this.gigabloxFactory.transition(
          event.data.gigabloxLayout,
          async () => {
            // switched to new layout
            if (event.data.blockDistribution !== '1-1-1-1-1') {
              this.visible = true;
              await this.doModifier(event.data.blockDistribution);
              modifierResolver();
            } else {
              // no effect to play - resolve immediately
              modifierResolver();
            }
          },
          () => {
            // switch finished
            transitionResolver();
          }
        );

        await Promise.all([transitionPromise, modifierPromise]);
        // this.visible = false;
        event.leave();
        console.log('GigaBloxIntroAnim:onBlockDistribution - leaving event');
      } else {
        // same layout - nothing to see here
      }
    }

    startEmitters(emitters) {
      for (let i = 0; i < emitters.length; i++) {
        emitters[i].particleEmitter.emit = true;
      }
    }

    stopEmitters(emitters) {
      for (let i = 0; i < emitters.length; i++) {
        emitters[i].particleEmitter.emit = false;
      }
    }

    async doModifier(blockDistribution) {
      console.log('GigaBloxIntroAnim:doModifier - started');

      // so lets await a bit, this should give the reels time to revert back to 1-1-1-1-1

      soundManager.play('bigReelAppear');

      this.startEmitters(this.particlesPerPattern[blockDistribution]);

      await timerManager.delayAsync(750);

      // this.stopEmitters(this.particlesPerPattern[blockDistribution]);

      // await timerManager.delayAsync(250);

      console.log('GigaBloxIntroAnim:doModifier - finished');
    }
  }

  //////////////////////////////////////////////////
  create = function (json) {
    return new GigaBloxIntroAnim();
  };

  //////////////////////////////////////////////////
  initialise = function (json, container, resources) {
    container.initialise();
  };

  //////////////////////////////////////////////////
  getFilesRequired = function (json) {
    return ['', ''];
  };

  resourceManager.registerObjectType('GigaBloxIntroAnim', create, initialise, getFilesRequired);
})();
